// extracted by mini-css-extract-plugin
export default {"link":"BaseButton_link__+2dGC","arrow":"BaseButton_arrow__yxtSz","linkText":"BaseButton_linkText__sRdzT"};